import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'prettySeconds',
  standalone: false,
})
export class PrettySecondsPipe implements PipeTransform {
  transform(input: any): any {
    if (Number.isNaN(input)) {
      return null;
    }

    const totalSeconds = Math.trunc(input);
    const seconds = totalSeconds % 60;
    const hours = Math.trunc((totalSeconds - seconds) / 60 / 60);
    const minutes = Math.trunc((totalSeconds - seconds - hours * 60 * 60) / 60);
    if (totalSeconds < 60) {
      return seconds + 's';
    }

    return (hours > 0 ? hours + 'h ' : '') + (minutes > 0 ? minutes + 'm ' : '') + (seconds + 's');
  }
}
